<template>
  <div class="filter">
    <div class="label-title">
      {{ $t('view-Search.filter-title.archetype') }}
    </div>
    <div class="">
      <div class="d-flex flex-wrap justify-content-center">
        <archetype-circle
          v-model="archetype"
        />
      </div>
    </div>
  </div>
</template>

<script>
import archetypesCircle from '../../../components/ArchetypesCircle'

export default {
  components: {
    'archetype-circle': archetypesCircle
  },
  props: {
    value: {
      type: [Number, Array],
      default: null
    }
  },
  computed: {
    archetype: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
